var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNameImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7417 12.228C12.6194 12.188 11.8463 11.8395 12.3294 10.371H12.3225C13.5817 9.07411 14.544 6.98719 14.544 4.93257C14.544 1.77334 12.4433 0.117188 10.0017 0.117188C7.55865 0.117188 5.46942 1.77257 5.46942 4.93257C5.46942 6.99565 6.42635 9.09103 7.69327 10.3849C8.18712 11.6803 7.30404 12.161 7.11942 12.2287C4.5625 13.1533 1.5625 14.8387 1.5625 16.5026V17.1264C1.5625 19.3933 5.95788 19.9087 10.0256 19.9087C14.0994 19.9087 18.4394 19.3933 18.4394 17.1264V16.5026C18.4394 14.7887 15.4248 13.1164 12.7417 12.228Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNameImage);
export default __webpack_public_path__ + "static/media/name_image.9b7d2f00dc23fa8e3d8665e03639d7b1.svg";
export { ForwardRef as ReactComponent };